import React, {FC, memo} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, IRootState} from "../store/configureStore";
import {actions, IModal} from "../store/sliceModal";
import ModalError from "./error/ModalError";
import ModalVewImage from "./ModalVewImage/ModalVewImage";
import ModalCreateRename from "./ModalCreateRename/ModalCreateRename";
import ModalMove from "./move/ModalMove";
import ModalMedia from "./modalMedia/ModalMedia";
import ModalCamera from "./modalCamera/ModalCamera";
import ModalKettle from "./modalKettle/ModalKettle";
import ModalReceiver from "./modalReceiver/ModalReceiver";
import ModalAccess from "./modalAccess/ModalAccess";
import ModalCameraAll from "./modalCamera/ModalCameraAll";
import ModalIframe from "./iframeModal/ModalIframe";
import ModalPerson from "./modalPerson/ModalPerson";
import ModalSuccess from "./success/ModalSuccess";

const Modals: FC = () => {

    const dispatch = useDispatch<AppDispatch>();
    const modal: IModal = useSelector((state: IRootState) => state.modal)

    return (
        <>
            <ModalError
                show={modal.error}
                onHide={() => dispatch(actions.closeErrorModal())}
                text={modal.messageError}
            />
            <ModalSuccess
                show={modal.success}
                onHide={() => dispatch(actions.closeSuccessModal())}
                text={modal.messageSuccess}
            />
            <ModalVewImage
                show={modal.cardModal}
                id={modal.cardModel.id}
                name={modal.cardModel.name}
                image={modal.cardModel.image}
                publicPath={modal.cardModel.publicPath}
                onHide={() => dispatch(actions.closeCardModal())}/>

            <ModalCreateRename
                show={modal.createRenameModal}
                onHide={() => dispatch(actions.closeCreateRenameModal())}
                title={modal.createRenameModel.title}
                file={modal.createRenameModel.file}
                isRename={modal.createRenameModel.isRename}
                id={modal.createRenameModel.id}
            />
            <ModalMove
                show={modal.moveModal}
                onHide={() => dispatch(actions.closeMoveModal())}
                title={modal.moveModalModel.title}
                file={modal.moveModalModel.file}
                ids={modal.moveModalModel.ids}
            />
            <ModalMedia
                show={modal.mediaModal}
                onHide={() => dispatch(actions.closeMediaModal())}
                file={modal.mediaModalModel.file}
                isAudio={modal.mediaModalModel.isAudio}
                publicPath={modal.mediaModalModel.publicPath}
            />
            <ModalCamera
                show={modal.cameraModal}
                onHide={() => dispatch(actions.closeCameraModal())}
                camera={modal.cameraModalModel}
            />
            <ModalCameraAll
                show={modal.cameraAllModal}
                onHide={() => dispatch(actions.closeCameraAllModal())}
                camera={modal.cameraAllModalModel}
            />
            <ModalAccess
                show={modal.accessModal}
                onHide={() => dispatch(actions.closeAccessModal())}
                fileId={modal.accessModalModel}
            />
            <ModalIframe
                show={modal.iframeModal}
                onHide={() => dispatch(actions.closeIframeModal())}
                file={modal.iframeModalModel.file}
                publicPath={modal.iframeModalModel.publicPath}
            />

            <ModalPerson
                show={modal.personModal}
                onHide={() => dispatch(actions.closePersonModal())}
                person={modal.personModel}
            />

            {/*<ModalKettle*/}
            {/*    show={modal.kettleModal}*/}
            {/*    onHide={() => dispatch(actions.closeKettleModal())}*/}
            {/*/>*/}
            {/*<ModalReceiver*/}
            {/*    show={modal.receiverModal}*/}
            {/*    onHide={() => dispatch(actions.closeReceiverModal())}*/}
            {/*/>*/}
        </>
    )

}

export default memo(Modals)
